import { render, staticRenderFns } from "./StartPage.vue?vue&type=template&id=67b7143d&scoped=true&"
import script from "./StartPage.vue?vue&type=script&lang=js&"
export * from "./StartPage.vue?vue&type=script&lang=js&"
import style0 from "./StartPage.vue?vue&type=style&index=0&id=67b7143d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b7143d",
  null
  
)

export default component.exports